<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import EmployeeDetailWorkDetails from '../../../../../../employees/components/EmployeeDetailWorkDetails.vue'

import { Employee } from '../../../../../../employees/models/employee'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { employee } = defineProps<{
  employee: Employee
}>()
</script>

<template>
  <EmployeeDetailWorkDetails :employee-id="employee.id" :employee="employee" />
</template>
